import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultOrderData, getOrderById, updateOrder, createOrder, getOrderInfo } from '@/api/order';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import FileUpload from '@/components/FileUpload/index.vue';
import OrderInfoTab from './OrderInfoTab.vue';
import OrdersProductEdit from './OrdersProductEdit.vue';
import { AdminModule } from '@/store/modules/admin';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, defaultOrderData);
    this.orderInfoData = null;
    this.loading = false;
    this.isEditAllowed = false;
    this.loggedInAdmin = null;
    this.statusOptions = [{
      label: 'Confirm',
      key: 'Order Confirmed'
    }, {
      label: 'Cancel',
      key: 'Order Cancelled'
    }];
    this.rules = {
      status: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }],
      comments: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 500,
        message: 'Length should be 3 to 500',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    if (AdminModule.roles.includes('Unit Manager') || AdminModule.roles.includes('Super Admin')) {
      this.isEditAllowed = true;
    }
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(id);
    } else {
      this.formData = Object.assign({}, defaultOrderData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getOrderById(id);
      this.formData = data;
      switch (this.formData.status) {
        case 'Order Placed':
        case 'Partial Payment':
          this.statusOptions = [{
            label: 'Confirm Order',
            key: 'Order Confirmed'
          }, {
            label: 'Cancel Order',
            key: 'Order Cancelled'
          }];
          break;
        case 'Order Dispatched':
          this.statusOptions = [{
            label: 'Delivered',
            key: 'Order Delivered'
          }];
          break;
        case 'Not Delivered':
          this.statusOptions = [{
            label: 'Delivered',
            key: 'Order Delivered'
          }];
          break;
        case 'Order Delivered':
          this.statusOptions = [{
            label: 'Delivery Confirmed',
            key: 'Delivery Confirmed'
          }];
          break;
        case 'Partial Dispatch':
          this.statusOptions = [{
            label: 'Order Partial Cancelled',
            key: 'Order Partial Cancelled'
          }];
          break;
        case 'Delivery Confirmed':
          this.statusOptions = [];
          break;
      }
      // for order info display
      this.orderInfoData = await getOrderInfo(id);
      // Just for test
      const title = this.formData.orderReference;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.formData.status === 'Order Confirmed') {
        this.formData.comments = '';
      }
      if (this.isEdit) {
        await updateOrder(this.formData.id, this.formData);
      } else {
        await createOrder(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Order saved successfully',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/order/list',
        query: this.$route.query
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'OrderDetail',
  components: {
    FileUpload,
    OrderInfoTab,
    OrdersProductEdit
  }
})], default_1);
export default default_1;